<template>
  <div class="page-loader">
    <h3>HELOOOO</h3>
  </div>
</template>

<style lang="css" scoped>
.page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: black;
  z-index: 999;
}
.cube{
  width: 40px;
  height: 40px;
  margin-right: 10px;

}

.cube:first-child {
  animation: left 1s infinite;
}
.cube:last-child {
   animation: right 1s infinite .5s;
 }

@keyframes left {
  40% {
    transform: translateX(-60px);
  }
  50% {
    transform: translateX(0);
  }
}
@keyframes right {
  40% {
    transform: translateX(60px);
  }
  50% {
    transform: translateX(0);
  }
}
</style>